import { render, staticRenderFns } from "./DonutConsultationsISTByHoraires.vue?vue&type=template&id=00463c70&"
import script from "./DonutConsultationsISTByHoraires.vue?vue&type=script&lang=ts&"
export * from "./DonutConsultationsISTByHoraires.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports